export default __webpack_public_path__ + "static/media/035-easel.7e88ae17.svg";